/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Meta_Ogtitle1Inputs */

const ja_company_meta_ogtitle1 = /** @type {(inputs: Company_Meta_Ogtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`株式会社プレイブレーン - 会社概要`)
};

const en_company_meta_ogtitle1 = /** @type {(inputs: Company_Meta_Ogtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN - Company`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN - Company" |
*
* @param {Company_Meta_Ogtitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_meta_ogtitle1 = /** @type {((inputs?: Company_Meta_Ogtitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Meta_Ogtitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_meta_ogtitle1(inputs)
	return en_company_meta_ogtitle1(inputs)
});
export { company_meta_ogtitle1 as "company_meta_ogTitle" }